import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export interface AuditActor {
  id: string;
  name: string;
  email: string;
  role: string;
}

export interface AuditLogEntry {
  id: string;
  action: string;
  entityType: string;
  entityId: string;
  actorUserId: string | null;
  actor: AuditActor | null;
  ip: string | null;
  userAgent: string | null;
  before: unknown;
  after: unknown;
  createdAt: string;
}

export interface AuditLogsResponse {
  data: AuditLogEntry[];
  meta: { page: number; limit: number; total: number };
}

export interface AuditFacetsResponse {
  data: {
    actions: Array<{ value: string; count: number }>;
    entityTypes: Array<{ value: string; count: number }>;
  };
}

export interface AuditFilters {
  page?: number;
  limit?: number;
  q?: string;
  action?: string;
  entityType?: string;
  actorUserId?: string;
  fromDate?: string;
  toDate?: string;
}

export function useAuditLogs(params: AuditFilters) {
  return useQuery({
    queryKey: ['audit-logs', params],
    queryFn: async () => {
      const { data } = await api.get<AuditLogsResponse>('/audit-logs', { params });
      return data;
    },
  });
}

export function useAuditFacets() {
  return useQuery({
    queryKey: ['audit-logs', 'facets'],
    queryFn: async () => {
      const { data } = await api.get<AuditFacetsResponse>('/audit-logs/facets');
      return data.data;
    },
    staleTime: 60_000,
  });
}
